import { fetchBlockNumber } from 'api/galaxyApi';
import {
  CHAIN_BY_ID,
  CHAINS,
  DEFAULT_CHAIN_ID,
  NATIVE_TOKENS,
  WRAPPED_NATIVE_TOKENS,
} from 'consts';
import { makeAutoObservable, reaction } from 'mobx';
import { WalletId } from 'types';
import { Address } from 'viem';

type BalancesMap = Record<number, Record<Address, string | undefined>>;

export class Web3Store {
  chainId: number = DEFAULT_CHAIN_ID;
  account: Address | undefined = undefined;
  walletId: WalletId | undefined = undefined;
  currentBlock: number = 0;

  balancesMap: BalancesMap = {};

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });

    reaction(
      () => this.account,
      () => {
        if (!this.account) {
          this.balancesMap = {};
        }
      }
    );
  }

  syncWeb3Data = (data: { account: Address | undefined; walletId: WalletId | undefined }) => {
    this.account = data.account;
    this.walletId = data.walletId;
  };

  setChainId = (chainId: number) => {
    this.chainId = chainId;
  };

  addBalances = (chainId: number, balances: Record<Address, string | undefined>) => {
    this.balancesMap = {
      ...this.balancesMap,
      [chainId]: { ...this.balancesMap[chainId], ...balances },
    };
  };

  get balances() {
    return this.balancesMap[this.chainId] || {};
  }

  get nativeToken() {
    return NATIVE_TOKENS[this.chainId];
  }

  get wrappedNativeToken() {
    return WRAPPED_NATIVE_TOKENS[this.chainId];
  }

  get chain() {
    return CHAIN_BY_ID[this.chainId];
  }

  get isDevnet() {
    return this.chainId === CHAINS.devnet.id;
  }

  setCurrentBlock(block: number) {
    this.currentBlock = block;
  }

  async pollBlockNumber() {
    try {
      const block = await fetchBlockNumber();
      this.currentBlock = block;
    } catch (error) {
      console.error('Failed to fetch block number:', error);
    }
  }
}
